<template>
  <div class="app-menu navbar-menu" style="background-color: 11eE1E !important">
    <div class="navbar-brand-box ">
      <RouterLink to="/" class="logo logo-dark">
        <span class="logo-lg">
          <img src="/images/logo_main1.png" alt="" height="40" />
        </span>
      </RouterLink>
    </div>

    <div id="scrollbar">
      <div class="container-fluid">
        <ul class="navbar-nav" id="navbar-nav">
          <li
            v-for="(item, index) in displayMenu"
            :key="index"
            :class="{ 'selected-menu': $route.path === item.route }"
            :id="item.id"
            @click="selectedItem = item.label"
          >
            <router-link class="nav-link menu-link" :to="item.route">
              <i class="nav-item" :class="item.icon"></i>
              <span
                class="nav-item"
                style="font-size: 14px; margin-left: 20px"
                >{{ item.label }}</span
              >
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { adminMenu, superAdminMenu } from "@/constants/sidebarmenu";

export default {
  name: "sidebarUI",

  data() {
    return {
      selectedItem: null,
      displayMenu: [],
    };
  },

  mounted() {
    const accessToken = Cookies.get("accessToken");
    if (accessToken) {
      var ldata = JSON.parse(localStorage.getItem("ldata"));
      if (ldata.role == "superadmin") {
        this.displayMenu = superAdminMenu;
      } else {
        this.displayMenu = adminMenu;
      }
    }
  },
};
</script>

<style scoped>
.selected-menu {
  border-left: 4px solid white;
  background-color: rgb(255, 255, 255, 0.1);
}

.nav-item {
  color: white !important;
}
.app-menu {
  background-color: #363740;
}
</style>
